import styled from 'styled-components'
import DesktopPurchaseHistories from 'components/desktop/page/Purchases/Histories'

const PurchaseHistories = styled(DesktopPurchaseHistories)``

export default PurchaseHistories
